/* Commenting the following code for FAST.Ray using AI Agent. 23/07/2026. Comment Start */
// import React, { useEffect } from 'react'
/* Commenting end. Ray using AI Agent. 23/07/2026 */
/* Commenting the following code for FAST.dev using AI Agent. Monday Jul 27, 2026. Comment Start */
// import React from 'react'
// import { Navigate, Outlet } from 'react-router-dom'
/* Commenting end. dev using AI Agent. Monday Jul 27, 2026 */
/* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */
/* Commenting the following code for testit.ray using AI Agent. 2026-08-07. Comment Start */
// Sticky footer removed — unused footer imports kept commented.
// import React, { useEffect, useRef, useState } from 'react'
// import { Link, Navigate, Outlet, useLocation } from 'react-router-dom'
// import { ... activityTypeChip, explainNextTopicLock, ... } from '../progressAccordion'
/* Commenting end. ray using AI Agent. 2026-08-07 */
/* Added the following code for testit.ray using AI Agent. 2026-08-07. Code Start */
/* Commenting the following code for route_load.ray using AI Agent. Aug 12, 2026. Comment Start */
// import React from 'react'
// import { Navigate, Outlet } from 'react-router-dom'
/* Commenting end. ray using AI Agent. Aug 12, 2026 */
/* Added the following code for route_load.ray using AI Agent. Aug 12, 2026. Code Start */
import React, { Suspense } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
/* Code end. ray using AI Agent. Aug 12, 2026 */
import { ProgressProvider, useProgress } from '../context/ProgressContext'
/* Code end. ray using AI Agent. 2026-08-07 */
/* Added the following code for progress.ray using AI Agent. 28/07/2026. Code Start */
import { toNavigableProgressPath } from '../pagePathUtils'
import { normalizePageSlug } from '../progressApi'
/* Code end. ray using AI Agent. 28/07/2026 */
/* Code end. Ray using AI Agent. 27/07/2026 */
import Header from './Header'
import Resside from './Resside'

/**
 * Gated outlet: suppresses mounting locked lesson components when typed in URL,
 * showing a seamless skeleton until the lock redirect executes (zero flash).
 */
function GatedOutlet() {
  const location = useLocation();
  /* Added the following code for lock_gate.ray using AI Agent. 20/08/2026. Code Start */
  const {
    isPathLocked,
    lockMap,
    locksReady = true,
    isAdminUser,
    viewAs,
    learnerPreview,
    PROGRESS_SKIP_PREFIXES = [],
  } = useProgress();
  /* Code end. ray using AI Agent. 20/08/2026 */
  /* Commenting the following code for lock_gate.ray using AI Agent. 20/08/2026. Comment Start */
  // const { isPathLocked, lockMap, PROGRESS_SKIP_PREFIXES = [] } = useProgress();
  /* Commenting end. ray using AI Agent. 20/08/2026 */
  const path = location.pathname || "";

  const isSkippedPath = PROGRESS_SKIP_PREFIXES.some(
    (p) => path === p || path.startsWith(`${p}/`)
  );

  /* Added the following code for lock_gate.ray using AI Agent. 20/08/2026. Code Start */
  // Admins outside view-as / preview are not gated by linear locks.
  const bypassLocks = isAdminUser && !viewAs?.userId && !learnerPreview;
  const pendingLocks = !bypassLocks && !isSkippedPath && !locksReady;
  const locked = !bypassLocks && !isSkippedPath && locksReady && isPathLocked(path);

  if (pendingLocks || locked) {
    return (
      <PageContentSkeleton
        pageName={
          locked && lockMap?.lockMessage ? "Content Locked" : "Loading..."
        }
      />
    );
  }
  /* Code end. ray using AI Agent. 20/08/2026 */
  /* Commenting the following code for lock_gate.ray using AI Agent. 20/08/2026. Comment Start */
  // const locked = !isSkippedPath && isPathLocked(path);
  // if (locked) {
  //   return (
  //     <PageContentSkeleton
  //       pageName={lockMap?.lockMessage ? "Content Locked" : "Loading..."}
  //     />
  //   );
  // }
  /* Commenting end. ray using AI Agent. 20/08/2026 */

  return (
    <Suspense fallback={<PageContentSkeleton />}>
      <Outlet />
    </Suspense>
  );
}

/* Added the following code for progress.ray using AI Agent. 28/07/2026. Code Start */
/**
 * On first visit to a topic that has the header video control, open the video panel
 * so CustomVideoPlayer can mount and autoplay.
 */
function LessonVideoFirstVisitOpen() {
  /* Commenting the following code for testit.ray using AI Agent. 2026-08-07. Comment Start */
  // Auto-clicking "Watch Video" on topic open caused videos to start without a play press.
  // const location = useLocation();
  // const { progress } = useProgress();
  // useEffect(() => {
  //   ... openBtn.click(); ...
  // }, [location.pathname, progress?.checklist]);
  /* Commenting end. ray using AI Agent. 2026-08-07 */
  /* Added the following code for testit.ray using AI Agent. 2026-08-07. Code Start */
  // No-op: video opens only when the learner clicks Watch Video.
  return null;
  /* Code end. ray using AI Agent. 2026-08-07 */
}
/* Code end. ray using AI Agent. 28/07/2026 */

/* Commenting the following code for progress.ray using AI Agent. 28/07/2026. Comment Start */
// Previous NextTopicFooter only rendered after checklist completion — easy to miss.
// function NextTopicFooter() { ... showNextTopic = checklistComplete && ... }
/* Commenting end. ray using AI Agent. 28/07/2026 */

/* Commenting the following code for progress.ray using AI Agent. 28/07/2026. Comment Start */
// Sticky global Next bar — appeared on Dashboard/hubs via stale progress context.
// function NextTopicFooter() { ... sticky bottom-0 ... hasLessonContext without path match ... }
/* Commenting end. ray using AI Agent. 28/07/2026 */

/* Commenting the following code for menu.ray using AI Agent. 28/07/2026. Comment Start */
// Previous NextTopicFooter used a disabled Continue when incomplete and vague lock copy.
// function NextTopicFooter() { ... disabled Continue / "This topic is still locked." ... }
/* Commenting end. ray using AI Agent. 28/07/2026 */

/* Added the following code for menu.ray using AI Agent. 28/07/2026. Code Start */
/**
 * Sticky leave-lesson bar: pinned to the bottom of the content column (not page end).
 * Sidebar owns in-page jumps; this control owns finishing / leaving the lesson.
 */
function pathsReferToSamePage(a, b) {
  const left = normalizePageSlug(toNavigableProgressPath(a || "") || a || "");
  const right = normalizePageSlug(toNavigableProgressPath(b || "") || b || "");
  return !!left && !!right && left === right;
}

function NextTopicFooter() {
  /* Added the following code for testit.ray using AI Agent. 2026-08-07. Code Start */
  // Sticky leave-lesson bar removed - progress actions stay in the sidebar rail.
  return null;
  /* Code end. ray using AI Agent. 2026-08-07 */
  /* Commenting the following code for testit.ray using AI Agent. 2026-08-07. Comment Start */
  /*
  const location = useLocation();
  const {
    progress,
    lockMap,
    PROGRESS_SKIP_PREFIXES: skipPrefixes = [],
  } = useProgress();
  ... sticky leave-lesson footer UI ...
  */
  /* Commenting end. ray using AI Agent. 2026-08-07 */
}
/* Code end. ray using AI Agent. 28/07/2026 */

/* Added the following code for route_load.ray using AI Agent. Aug 12, 2026. Code Start */
/**
 * Lesson-shaped placeholder for the main column while a lazy route chunk loads.
 * Header and sidebar stay mounted; only this outlet fallback swaps in.
 */
function titleFromPathname(pathname) {
  const slug = (pathname || "").split("/").filter(Boolean).pop() || "";
  if (!slug) return "";
  return slug
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function PageContentSkeleton({ pageName }) {
  const location = useLocation();
  const title = pageName || titleFromPathname(location.pathname);
  return (
    <div className="font-sans items-center text-left min-h-full flex flex-col">
      {/* Added the following code for lesson_ui.ray using AI Agent. 2026-08-24. Code Start */}
      <div className="container mx-auto md:w-1/2 lg:w-full xl:w-full pt-10 pl-8 pr-8 pb-8 flex-grow">
      {/* Code end. ray using AI Agent. 2026-08-24 */}
      {/* Commenting the following code for lesson_ui.ray using AI Agent. 2026-08-24. Comment Start */}
      {/* <div className="container mx-auto md:w-1/2 lg:w-full xl:w-full overflow-hidden pt-10 pl-8 pr-8 flex-grow"> */}
      {/* Commenting end. ray using AI Agent. 2026-08-24 */}
        <div className="text-center rounded-t-xl py-4 w-full bg-[#044661] text-white relative">
          {title ? (
            <h2 className="text-xl">{title}</h2>
          ) : (
            <div className="mx-auto h-6 w-48 rounded bg-white/25 animate-pulse" />
          )}
        </div>
        <div className="border-2 border-gray-300 bg-white shadow-lg p-6 min-h-[559px]">
          <div className="h-4 w-3/4 max-w-xl rounded bg-slate-200 animate-pulse mb-4" />
          <div className="h-4 w-full max-w-2xl rounded bg-slate-200 animate-pulse mb-4" />
          <div className="h-4 w-5/6 max-w-2xl rounded bg-slate-200 animate-pulse mb-4" />
          <div className="h-4 w-2/3 max-w-xl rounded bg-slate-200 animate-pulse mb-4" />
          <div className="h-4 w-1/2 max-w-lg rounded bg-slate-200 animate-pulse" />
        </div>
      </div>
    </div>
  );
}
/* Code end. ray using AI Agent. Aug 12, 2026 */

const ProtectedLayout = ({ permissions, routePermits, reloader, navLoading }) => {
  const token = localStorage.getItem("token");

  /* Commenting the following code for FAST.Ray using AI Agent. 23/07/2026. Comment Start */
  // Duplicate nav fetch: index.js already loads permissions on mount and on auth-login.
  // useEffect(() => {
  //   if (token && reloader) {
  //     reloader();
  //   }
  // }, [reloader, token]);
  /* Commenting end. Ray using AI Agent. 23/07/2026 */

  if (!token) {
    return <Navigate to={"/"} />;
  }

  return (
    <div className='flex flex-col h-screen ml-1 mr-1'>
      <Header />
      {/* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */}
      <ProgressProvider>
      {/* Code end. Ray using AI Agent. 27/07/2026 */}
      {/* Added the following code for raymenusstructure.ray using AI Agent. 2026-07-14. Code Start */}
      {/* flex-1 + min-h-0 so the row uses remaining height below the header;
          overflow-hidden prevents the sidebar from growing past the viewport. */}
      <div className='flex flex-1 min-h-0 overflow-hidden'>
        <div className='w-fit h-full min-h-0'>
          {/* Added the following code for progress_tracking.ray using AI Agent. 21/07/2026. Code Start */}
          <Resside permissions={permissions} routePermits={routePermits} loading={navLoading} />
          {/* Code end. ray using AI Agent. 21/07/2026 */}
        </div>
        {/* Added the following code for menu.ray using AI Agent. 28/07/2026. Code Start */}
        {/* Content scrolls in the main column (leave-lesson sticky bar removed). */}
        <div className='flex flex-1 min-h-0 flex-col bg-slate-200 text-sm'>
          {/* Added the following code for lesson_ui.ray using AI Agent. 2026-08-24. Code Start */}
          {/* Extra bottom padding so lesson card borders/shadows are not clipped. */}
          <div className='flex-1 min-h-0 overflow-y-auto pb-8'>
          {/* Code end. ray using AI Agent. 2026-08-24 */}
          {/* Commenting the following code for lesson_ui.ray using AI Agent. 2026-08-24. Comment Start */}
          {/* <div className='flex-1 min-h-0 overflow-y-auto pb-4'> */}
          {/* Commenting end. ray using AI Agent. 2026-08-24 */}
            {/* Added the following code for route_load.ray using AI Agent. Aug 12, 2026. Code Start */}
            <GatedOutlet />
            {/* Code end. ray using AI Agent. Aug 12, 2026 */}
            {/* Commenting the following code for route_load.ray using AI Agent. Aug 12, 2026. Comment Start */}
            {/* <Outlet /> */}
            {/* Commenting end. ray using AI Agent. Aug 12, 2026 */}
            {/* Added the following code for progress.ray using AI Agent. 28/07/2026. Code Start */}
            <LessonVideoFirstVisitOpen />
            {/* Code end. ray using AI Agent. 28/07/2026 */}
          </div>
          {/* Commenting the following code for testit.ray using AI Agent. 2026-08-07. Comment Start */}
          {/* <NextTopicFooter /> */}
          {/* Commenting end. ray using AI Agent. 2026-08-07 */}
        </div>
        {/* Code end. ray using AI Agent. 28/07/2026 */}
        {/* Commenting the following code for menu.ray using AI Agent. 28/07/2026. Comment Start */}
        {/* <div className='flex-1 min-h-0 overflow-y-auto pb-10 bg-slate-200 text-sm'>
          <Outlet />
          <LessonVideoFirstVisitOpen />
          <NextTopicFooter />
        </div> */}
        {/* Commenting end. ray using AI Agent. 28/07/2026 */}
      {/* Code end. ray using AI Agent. 2026-07-14 */}
      </div>
      {/* Added the following code for FAST.Ray using AI Agent. 27/07/2026. Code Start */}
      </ProgressProvider>
      {/* Code end. Ray using AI Agent. 27/07/2026 */}
    </div>
  );
};

export default ProtectedLayout;
